import React, { useCallback, useContext, useState } from 'react';
import { xs_isMobile } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { ReservationPrinter } from '../../data/betslip/reservation-detail/ReservationPrinter';
import SocialButtons from '../../data/my-bets/SocialButtons';
import { formatDate } from '../../data/utils/formatDate';
import { getDBTimestampFromDate } from '../../data/utils/getDBTimestampFromDate';
import { getBetslipPage } from '../../data/utils/getBetslipPage';
import { labels } from '../../data/labels';

function getFormattedDate(timestamp) {
    const reservationDate = new Date();
    reservationDate.setTime(timestamp);
    return formatDate(getDBTimestampFromDate(reservationDate), true).formatted;
}

function ReservationHistory(props) {
	const betslipContext = useContext(BetslipContext) ;
	const [printCodes, setPrintCodes] = useState(null);
    
    function printReservation(code) {
		setPrintCodes({codeList : [code]});
    }

    let reservations = props.reservations;
    const getTicketURL = useCallback((code) => {
//        const baseURL = getBaseURL();
    	//const baseURL = (loadedInIframe()?window.top:window.self).location.origin;
        const baseURL = window.location.origin;
    	const betslipPage = getBetslipPage(xs_isMobile);
        return `${baseURL}${betslipPage}?reservationCode=${code}`;
    }, []);
    
    return (
        <div className="reservationHistory">
        	{printCodes && <ReservationPrinter codeList={printCodes.codeList} endFunction={() => { setPrintCodes(null); }} />}
            <div className="reservationHeader">{labels['betslip.reservations_made']}: {reservations.length}</div>
            <div className="reservationListContainer">		
                {reservations.map(function(res) {
                    const reactKey = `reservation-${res.code}`;
                    return <React.Fragment key={reactKey}>
                        <div className="reservationRow">
                            <div onClick={() => {betslipContext.removeReservation(res.code)}} className="deleteReservation pointer"><i className="fa fa-times"></i></div>
                            <div className="inputReservationContainer reservationData">
                                <span className="reservationTimestamp">{getFormattedDate(res.timestamp)}</span>
                                <span className="margine-dx grassetto">{res.code}</span>
                            </div>
                            <div className="reservationButtonsContainer">
                                <div className="reservation-buttons-row">
                                    <div id="xs-reservation-detail-btn" onClick={() => betslipContext.openReservationDetail(res.code)} className="reloadReservationButton">
                                        <span>{labels['betslip.reservations.detail']}</span>
                                        <i className="fa fa-ticket-alt"></i>
                                    </div>
                                    <div id="xs-reservation-print-btn" onClick={() => printReservation(res.code)} className="reloadReservationButton">
                                        <span>{labels['betslip.reservations.print']}</span>
                                        <i className="fa fa-print"></i>
                                    </div>
                                    <div id="xs-reservation-reload-btn" onClick={() => betslipContext.reloadReservedTicket(res.code)} className="reloadReservationButton">
                                        <span>{labels['betslip.reservations.load']}</span>
                                        <i className="fa fa-shopping-cart"></i>
                                    </div>
                                </div>
                                <div className="reservation-buttons-row">
                                    <SocialButtons message={labels['betslip.reservations.share_ticket']} ticketUrl={getTicketURL(res.code)} />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                })}
            </div>
            <div className="closeReservationButtonContainer">
                <button onClick={() => betslipContext.toggleReservationBox()} className="bottone bg-rosso bianco">{labels['betslip.reservations.close']}</button>
            </div>
        </div>
   );
}

export default ReservationHistory;